<template>
  <div>
    <div class="congtent">
      <div class="congtentheader">
        <div class="congtentheadertext">{{ swiperList.text }}</div>
      </div>
      <!-- 个人默认回显 -->
      <div class="congtentmiddle" v-if="swiperList.userType == '1' &&swiperList.text != '公积金合作楼盘查询'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="name">
            <el-input v-model="ruleForm.idcrad" class="congtentmiddle_toptextinput" disabled></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="congtentmiddle" v-if="swiperList.text == '公积金合作楼盘查询'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="楼盘名称" prop="xmmc" :rules="{
            required: true,
            message: '请输入楼盘名称',
            trigger: 'blur',
          }">
            <el-input v-model="ruleForm.xmmc" class="congtentmiddle_toptextinput"
              placeholder="请输入楼盘名称" @input="(e) => changeInput('xmmc', e)"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="inputcode">
            <el-input v-model="ruleForm.inputcode" class="congtentmiddle_toptextinputmiddle"
              placeholder="请输入验证码"></el-input>
            <el-badge id="auth_code" class="congtentmiddle_box"></el-badge>
          </el-form-item>
          <el-form-item style="margin-left: 12px">
            <div class="congtentfooter">
              <div class="congtentfooterleft" @click="goQuery('ruleForm')">
                查询
              </div>
              <div class="congtentfooterright" @click="resetForm('ruleForm')">
                重置
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <!-- 结果页面 -->
      <div class="congtentresult" v-if="tableValshow == true" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="contentresulttextheader">
          <div class="contentresulttext">查询结果</div>
          <div class="contentresulttextdown" v-if="swiperList.print == true &&
              swiperList.text == '大庆公积金缴存证明打印' ||
            swiperList.text == '公积金异地贷款证明打印' 
         
            " @click="saveImg">
            下载
          </div>
        </div>
        <div v-if="tableVal.length != 0" class="congtentHaveresult">
          <div v-for="(item, index) in tableVal" :key="index" style="
              margin-top: 20px;
              display: flex;
              flex-wrap: wrap;
              flex-direction: row;
            ">
            <div v-for="(items, index) in item" :key="index" style="display: flex; flex-wrap: wrap; flex-direction: row">
              <div class="congtentHaveresulttopleft">
                <div class="congtentHaveresulttoplefttxt">
                  {{ items.title }}
                </div>
                <div class="congtentHaveresulttopleftnumber">
                  {{
                    items.body == ""
                    ? "-"
                    : items.title == "负责人" ||
                      items.title == "经费来源" ||
                      items.title == "男方姓名" ||
                      items.title == "女方姓名" ||
                      items.title == "职工姓名" ||
                      items.title == "投资人名称" ||
                      items.title == "姓名" ||
                      items.title == "父亲姓名" ||
                      items.title == "母亲姓名" ||
                      items.title == "孩子姓名"
                      ? desensitizeChineseName(items.body)
                      : items.title == "身份证号码" ||
                        items.title == "居民身份证号码" ||
                        items.title == "女方身份证号" ||
                        items.title == "男方身份证号" ||
                        items.title == "身份证号" ||
                        items.title == "父亲身份证号" ||
                        items.title == "证件号码" ||
                        items.title == "母亲身份证号" ||
                        items.title == "孩子身份证号" ||
                        items.title == "公民身份证号"
                        ? desensitizeIDNumber(items.body)
                        : items.title == "处罚决定书签发日期" ||
                          items.title == "受理日期" ||
                          items.title == "年报创建时间" ||
                          items.title == "操作日期" ||
                          items.title == "加入日期" ||
                          items.title == "有效日期截止到" ||
                          items.title == "交换时间戳" ||
                          items.title == "加入时间" ||
                          items.title == "成立日期" ||
                          items.title == "经营期限止" ||
                          items.title == "经营期限起" ||
                          items.title == "创建日期" ||
                          items.title == "（变更）核准日期" ||
                          items.title == "设立日期" ||
                          items.title == "时间戳" ||
                          items.title == "列入日期" ||
                          items.title == "移出日期" ||
                          items.title == "创建时间"
                          ? timestampToTime(items.body):items.title =="手机号码"?phoneNumber(items.body):
                     items.body
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tableVal.length == 0 && imgData == ''" class="congtentresultarr">
          <div class="contentresulttextline"></div>
          <img src="../assets/noreslute.png" class="congtentresultimg" />
          <div class="congtentresultimgtext">暂无结果</div>
        </div>
        <div class="congtentresultimage" v-if="type != 2">
          <img :src="imgData" />
        </div>
        <div class="congtentresultimage" v-if="type == 2">
          <img :src="imgData" style="width: 1140px; margin-top: 30px" />
        </div>
      </div>
   

      <!-- 公积金打印和个人参保打印 -->
      <div v-if="type" style="position: absolute; top: -99999px">
        <div class="mainCenterMains" ref="imgBox">
          <div class="MidSpaceTopTitles">
            <div style="height: 1px"></div>
            <div class="MidSpaceTopStyle">
              <div class="MidSpaceTopPic">
                <img class="h40" style="height: 35px" src="../assets/guohui.png" />
                <span style="font-size: 24px">大庆政务服务网</span>
              </div>
              <!-- <div>
                <span class="MidSpaceTopNum f18">查验流水号:</span>
                <span class="MidSpaceTopNum">{{ responseId }}</span>
              </div> -->
            </div>
            <div class="MidSpaceEr">
              <div class="MidSpaceName">{{ swiperList.text }}</div>
            </div>
            <div class="MidSpacePer1">
              <span>尊敬的</span>
              <span class="MidSpacePerName1">{{ loginInfo.username }}</span>
              <span class="MidSpacePerId1">{{ loginInfo.paperCode }}</span>
              <span class="MidSpacePerName1">:</span>
            </div>
            <div class="MidSpacePerInfo1">
              <span>您于</span>
              <span class="MidSpacePerData"> {{ timerNow }} </span>
              <span> 通过黑龙江省政务服务网</span>
              <span>查询</span>
              <span class="MidSpaceComName">{{ swiperList.text }}</span>
              <span>相关信息，查询结果如下 ：</span>
            </div>
            <div class="sTable">
              <div v-for="(item, index) in tableVal" :key="index"
                style="display: flex; flex-wrap: wrap; flex-direction: row">
                <div v-for="(items, index) in item" :key="index" style="
                    display: flex;
                    flex-wrap: wrap;
                    flex-direction: row;
                    margin: 0 auto;
                  ">
                  <div class="congtentHaveresulttoplefted">
                    <div class="congtentHaveresulttoplefttxted">
                      {{ items.title }}
                    </div>
                    <div class="congtentHaveresulttopleftnumbered">
                      {{
                        items.body == ""
                        ? "-"
                        : items.title == "负责人" ||
                          items.title == "经费来源" ||
                          items.title == "男方姓名" ||
                          items.title == "女方姓名" ||
                          items.title == "职工姓名" ||
                          items.title == "投资人名称" ||
                          items.title == "姓名" ||
                          items.title == "父亲姓名" ||
                          items.title == "母亲姓名" ||
                          items.title == "孩子姓名"
                          ? items.body
                          : items.title == "身份证号码" ||
                            items.title == "居民身份证号码" ||
                            items.title == "女方身份证号" ||
                            items.title == "男方身份证号" ||
                            items.title == "身份证号" ||
                            items.title == "父亲身份证号" ||
                            items.title == "证件号码" ||
                            items.title == "母亲身份证号" ||
                            items.title == "孩子身份证号" ||
                            items.title == "公民身份证号"
                            ? items.body
                            : items.title == "处罚决定书签发日期" ||
                              items.title == "受理日期" ||
                              items.title == "年报创建时间" ||
                              items.title == "操作日期" ||
                              items.title == "加入日期" ||
                              items.title == "有效日期截止到" ||
                              items.title == "交换时间戳" ||
                              items.title == "加入时间" ||
                              items.title == "成立日期" ||
                              items.title == "经营期限止" ||
                              items.title == "经营期限起" ||
                              items.title == "创建日期" ||
                              items.title == "（变更）核准日期" ||
                              items.title == "设立日期" ||
                              items.title == "时间戳" ||
                              items.title == "列入日期" ||
                              items.title == "移出日期" ||
                              items.title == "创建时间"
                              ? items.body
                              : items.body
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="MidSpaceBottom1">
              <span>我已核对以上信息，并承诺信息内容真实准确，如有虚假责任自负！</span>
            </div>
            <div class="MidSpaceBottom1">
              <span>本人签字：</span>
              <div class="Cross"></div>
            </div>
            <div class="MidSpaceBottomRight1">
              <img style="height: 120px; width: 120px; margin-top: -35px" src="../assets/yinzhang.png" />
              <div class="namesssss">大庆政务服务网</div>
              <div class="MidSpaceBottomRightDate1">
                {{ timerNow.split(" ")[0] }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 我要纠错 -->
      <div class="congtentfooterno" @click="gourl()">
        <img src="../assets/bottomicon.png" class="congtentfooternoimg" />
        <div class="congtentfooternotext">我要纠错</div>
      </div>
      <div class="congtentfooternotexttwo">
        本服务由大庆市住房公积金管理中心提供
      </div>
    </div>
  </div>
</template>

<script>
import appCollection from "@/common/appCollection.js";
import { GVerify } from "@/utils/jqGetCode.js";

import commonUtils from "@/utils/commonUtils.js";
import html2canvas from "html2canvas";
import { createsign, query, switchTicket, getAssessInfo } from "@/api/api";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    var checkinputcode = (rule, inputcode, callback) => {
      if (inputcode === "") {
        callback(new Error("验证码不能为空"));
      } else if (inputcode.length !== 4) {
        callback(new Error("验证码长度为4个字符!"));
      } else if (
        this.verifyCode.options.code.toLowerCase() !=
        this.ruleForm.inputcode.toLowerCase()
      ) {
        callback(new Error("验证码不正确!"));
      } else {
        callback();
      }
    };
    return {
      swiperListOrg: [
       
      {
    applicationId: "pc-gjjdkjdcxttyjk",
    text: "公积金贷款进度查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjhdjlcxxmvap",
    text: "公积金还贷记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjtqjlcxlxxka",
    text: "公积金提取记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjtqjdcxvnovp",
    text: "公积金提取进度查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjcjlcxudcjj",
    text: "公积金缴存记录查询",
    userType: 1,
  },
  {
    applicationId: "pc-gjjjcxxcxmxqdt",
    text: "公积金缴存信息查询",
    userType: 1,
  },
  {
		applicationId: "pc-gjjyddkzmdyyqqsa",
		text: "公积金异地贷款证明打印",
		print: true,
		userType: 1
	},
  {
		applicationId: "pc-gjjzxxxcxjpbpm",
		text: "公积金中心信息查询",
		userType: 1
	},
	{
		applicationId: "pc-gjjhzlpcxwgcla",
		text: "公积金合作楼盘查询",
		userType: 1
	},
  {
		applicationId: "pc-gjjywwdcxwiruu",
		text: "公积金业务网点查询",
		userType: 1
	},
  {
		applicationId: "pc-gjjdkxxcxnymin",
		text: "公积金贷款信息查询",
		userType: 1
	},
  {
		applicationId: "pc-dqgjjjczmdyphyzd",
		text: "大庆公积金缴存证明打印",
		userType: 1,
		print: true
	},
       
      ],
    
      tableVal: [],

      // 用户部分
      loginInfo: {},

      //弹窗部分
      showtaoast: false,
      ruleForm: {
        name: "",
        idcrad: "",
        inputcode: "",
        // 共享填写数据
        // 企业名称
        enterpriseName: "",
        // 联系人
        phonename: "",
        // 联系人手机号
        phone: "",
        phonenumber: "",
        // 服务类型
        ServiceType: "",
        // 说明
        desc: "",
        username: "",
        // 码上共享
        requirementTypeListseq: "",
        requirementStatusListseq: "",
        // 我向服务说句话
        wind: "",

        // 码上金融
        aralistSeq: "",
        enterpriseAddress: "",
        enterpriseCreate: "",
        optionSeq: "",
        money: "",
        collateral: "",
        banklistseq: "",
        // 新生儿
        birthCode: "",
        momName: "",
        momIdCode: "",
        // 个人高校学位证明办理打印
        certificateNumber: "",

        // 婚姻登记预约
        value1: "",
        sjd: "",
        // 婚姻关系证明
        nName: "",
        nIdcard: "",
        gName: "",
        gIdcard: "",
        //火化证明
        nameValue: "",
        idCardValue: "",

        // 事故
        value: "",
        //股权出质变更登记信息
        unitValue: "",
        paperCode: "",
        // 异常名录主体信息，
        marprId: "",
        xmmc:''
      },

      rules: {
        inputcode: [
          { validator: checkinputcode, trigger: "blur", required: true },
        ],
      },
      inputcode: "",
      tableValshow: false,
      imgData: "",
      isHaveHeaderInfo: false,
      HS_Infor: [],
      token: "",
      loading: false,
      type: "",
      // 码上共享
      requirementTypeList: [],
      requirementStatusList: [],
      // 我向服务说句话
      tableList: false,
      tableListadd: [],
      // 地区列表
      aralist: [],
      aralistSeq: "",
      banklist: [],
      banklistseq: "",
      options: [
        { loanType: 1, name: "首贷" },
        { loanType: 2, name: "续贷" },
      ],
      optionSeq: "",
      enterpriseCreate: "",
      newdata: "",
      type: true,
      timerNow: "",
      responseId: "",
      sjdoptions: [
        {
          val: 1,
          name: "上午",
        },
        {
          val: 2,
          name: "下午",
        },
      ],
    };
  },
  created() {
    this.timerNow = this.timeTurn(new Date().getTime());

    this.getshow();
  },
  mounted() {
    this.verifyCode = new GVerify("auth_code");
  },
  methods: {
    changeInput(type,e){
      console.log(e)
      let reg =
        /([`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#¥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、～]|[0-9|*|#]\uFE0F\u20E3)|([0-9|#]\u20E3)|([\u203C-\u3299]\uFE0F\u200D)|([\u203C-\u3299]\uFE0F)|([\u2122-\u2B55])|(\u303D)|([(\A9)|(\AE)]\u3030)|(\uA9)|(\uAE)|(\u3030)|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF])|([\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F])/g;
      setTimeout(() => {
        this.ruleForm[type] = e.replace(reg, "");
      }, 0);
    },
    getswitchTicket: async function () {
      var that = this;
      let datajson = {};
      let response = await switchTicket(datajson);
      console.log(response);
      if (
        Object.keys(response.data).length == 0 ||
        Object.keys(JSON.parse(response.data.resultDate).data).length == 0
      ) {
        that.$message({
          dangerouslyUseHTMLString: true,
          iconClass: "myicon",
          message:
            '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">请先登录！</div>',
        });
        setTimeout(function () {
          window.open(
            "https://www.zwfw.hlj.gov.cn/api-gateway/hljzwfw-jis-third-server/front/sso/appLogin?redirectUrl= " +
             'https://www.zwfw.hlj.gov.cn/jmopen_files/unzip/51050cd31c1d48dba6004dea6668f76b/pc-gjjzxxxcxjpbpm/index.html'

         );
       }, 2000)
        // that.getuserInfo('dacf9f62be8142e4972f85ede988c5b2');
      } else {
        that.getuserInfo(JSON.parse(response.data.resultDate).data.ticket);
      }
    },
   

   
    getshow: function () {
      console.log(appCollection.applicationName);
      var that = this;
      var param = {};
      param.name = appCollection.applicationName;
      if (param.name) {
        that.swiperList = that.swiperListOrg.find(
          (item) => item.text == param.name
        );

        that.getswitchTicket();
        document.querySelector('title').innerText =appCollection.applicationName ;
      } else {
        that.swiperList = {};
      }
    },
    getuserInfo: async function (ticket) {
      var that = this;
      let sign = null;
      let jmContent = commonUtils.sm2doEncrypt(ticket);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b56",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-d44b3ae76b56",
        version: "1.0",
        header: JSON.stringify({}),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698906441411",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);

      if (responseInfo.success && responseInfo.code != 401) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res);
        if (res.status == "200") {
          if (res.data.usertype == 2 && that.swiperList.userType == 1) {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">本服务仅支持个人账户使用!</div>',
            });
          } else if (res.data.usertype == 1 && that.swiperList.userType == 2) {
            that.$message({
              dangerouslyUseHTMLString: true,
              iconClass: "myicon",
              message:
                '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">本服务仅支持法人账户使用!</div>',
            });
          } else {
            if (res.data.uType == 1) {
              that.loginInfo = res.data;
              console.log(that.loginInfo);
              that.ruleForm.name = that.desensitizeChineseName(
                res.data.username
              );
              that.ruleForm.idcrad = that.desensitizeIDNumber(
                res.data.paperCode
              );
              that.ruleForm.username = that.desensitizeChineseName(
                res.data.username
              );
              that.ruleForm.phone = that.phoneNumber(res.data.mobile);
              that.token = res.token;
            } else if (res.data.uType == 2) {
              that.loginInfo = res.data;
              console.log(that.loginInfo);
              that.ruleForm.name = res.data.name;
              that.ruleForm.idcrad = res.data.credNum;
              that.ruleForm.username = that.desensitizeChineseName(
                res.data.username
              );
              that.ruleForm.phone = that.phoneNumber(res.data.mobile);
              that.ruleForm.paperCode = that.desensitizeIDNumber(
                res.data.corporationId
              );
              that.token = res.token;
            }
          }
        } else {
          that.$message({
            dangerouslyUseHTMLString: true,
            iconClass: "myicon",
            message:
              '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">获取用户信息失败!</div>',
          });
        }
      } else {
        that.$message({
          dangerouslyUseHTMLString: true,
          iconClass: "myicon",
          message:
            '<div style="display: flex;flex-direction: row; align-items: center;margin-left: 10px;;font-weight:bold">消息!</div>      <div style="color: rgba(102, 102, 102, 1);font-size: 14px;text-align: left;font-family: SourceHanSansSC-regular;margin-left: 8px;font-weight:bold">获取用户信息失败!</div>',
        });
      }
    },
    goQuery: async function (formName) {
      var that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
           that.text = that.swiperList.text;
           that.getuserAccumulationfund();

          } else {
            console.log(1111111)
            
              
          }

      })
    },
    gourl() {
      console.log(11111111111);
      window.open(
        "https://www.zwfw.hlj.gov.cn/api-gateway/jpaas-jact-web-server/front/mail-write.do?platformIid=779cfa340d3c4b1792664fbb1d0772f6&appname=" +
        appCollection.applicationName
      );
    },

    // 姓名脱敏
    desensitizeChineseName(name) {
      if (!name) {
        return "";
      }
      if (name.length <= 1) {
        return name;
      }
      const firstChar = name.charAt(0);
      const starCount = name.length - 1;
      const stars = "*".repeat(starCount);
      return firstChar + stars;
    },
    // 身份证号脱敏
    desensitizeIDNumber(idNumber) {
      if (!idNumber) {
        return "";
      }
      if (idNumber.length < 4) {
        return idNumber;
      }
      const lastFourDigits = idNumber.slice(-4);
      const stars = "*".repeat(idNumber.length - 4);
      return stars + lastFourDigits;
    },
    // 手机号脱敏
    phoneNumber(phoneNumber) {
      // 手机号仅显示前三位及后四位数字，隐藏信息用*代替
      return phoneNumber.substr(0, 3) + "****" + phoneNumber.substring(7);
    },
    // 转时间戳
    timestampToTime(timestamp) {
      timestamp = timestamp ? timestamp : null;
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      // let h =
      //   (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      // let m =
      //   (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      //   ":";
      // let s =
      //   date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
    resetForm(formName) {
      this.tableValshow = false;
      this.tableVal = [];
      this.tableList = false;
      this.tableListadd = [];
      this.$refs[formName].resetFields();
      this.getswitchTicket();
      this.verifyCode = new GVerify("auth_code");
    },

 

  
    // 公积金保存图片
    saveImg() {
      html2canvas(this.$refs.imgBox, {
        height: this.$refs.imgBox.scrollHeight,
        width: this.$refs.imgBox.scrollWidth,
      }).then((canvas) => {
        const link = document.createElement("a"); // 创建一个超链接对象实例
        link.download = appCollection.applicationName.slice(0, -2); // 设置要下载的图片的名称
        link.href = canvas.toDataURL(); // 将图片的URL设置到超链接的href中
        link.click(); // 触发超链接的点击事件
      });
    },
  
 
 

 
 
    // 获取公积金信息
    async getuserAccumulationfund() {
      var that = this;
      let type = "";
      let sign = null;
      if (that.text == "公积金贷款进度查询") {
        type = "0";
      } else if (that.text == "公积金还贷记录查询") {
        type = "1";
      } else if (that.text == "公积金提取记录查询") {
        type = "2";
      } else if (that.text == "公积金提取进度查询") {
        type = "3";
      } else if (that.text == "公积金缴存记录查询") {
        type = "4";
      } else if (that.text == "公积金缴存信息查询") {
        type = "5";
      } else if (that.text == "大庆公积金缴存证明打印") {
        type = "6";
      }else if (that.text == "公积金贷款信息查询") {
        type = "7";
      }else if (that.text == "公积金业务网点查询") {
        type = "8";
      }else if (that.text == "公积金合作楼盘查询") {
        type = "9";
      }else if (that.text == "公积金异地贷款证明打印") {
        type = "10";
      }else if (that.text == "公积金中心信息查询") {
        type = "11";
      }
      
      console.log(that.text)
      var data = {
        type: type,
        xmmc: this.ruleForm.xmmc?this.ruleForm.xmmc:''
      };
      let jmContent = commonUtils.sm2doEncrypt(JSON.stringify(data));
      let jmToken = commonUtils.sm2doEncrypt(that.token);
      let datajson = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-0001",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
      };
      let response = await createsign(datajson);
      if (response.success) {
        console.log(1111111);
        sign = response.data.sign;
      }
      let datajsonED = {
        app_id: that.swiperList.applicationId,
        interface_id: "f38bc28f-6e63-7dda-da33-0001",
        version: "1.0",
        header: JSON.stringify({
          access_token: jmToken,
        }),
        biz_content: JSON.stringify({
          param: jmContent,
        }),
        charset: "UTF-8",
        timestamp: "1698807504904",
        origin: 1,
        sign: sign,
      };
      let responseInfo = await query(datajsonED);

      if (
        responseInfo.success &&
        responseInfo.code != 401 &&
        responseInfo.code != 0
      ) {
        let realData = JSON.parse(responseInfo.data);
        let doDecrypt = commonUtils.sm2doDecrypt(realData.data);
        let res = JSON.parse(doDecrypt);
        console.log(res);
        if (res.status == "200") {
         let data = res.data
          if (!data) {
            that.tableValshow = true;
            that.tableVal = [];
            setTimeout(function () {
              that.loading = false;
            }, 2000);
          } else {
        
            var resDataTemp = [];
            data.forEach((items) => {
              let itemDataTemp = [];

              for (let key in items) {
                if (key != "result") {
                  itemDataTemp.push({
                    title: key,
                    body: items[key],
                  });
                }
              }
              resDataTemp.push(itemDataTemp);
            });
            console.log("最终值", resDataTemp);
            this.tableVal = resDataTemp;
            if (this.tableVal.length == 0 || this.tableVal[0].length == 0) {
              that.tableValshow = true;
              setTimeout(function () {
                that.loading = false;
              }, 2000);
              that.tableVal = [];
            } else {
              this.tableVal = resDataTemp;
              that.tableValshow = true;
              setTimeout(function () {
                that.loading = false;
              }, 2000);
            }
          }
        } else {
          that.tableValshow = true;
          setTimeout(function () {
            that.loading = false;
          }, 2000);
          that.tableVal = [];
        }
      } else {
        that.tableValshow = true;
        setTimeout(function () {
          that.loading = false;
        }, 2000);
        that.tableVal = [];
      }
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.congtent {
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
}

.congtentheader {
  width: 100%;
  height: 172px;
  background: url("../assets/background.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}

.congtentheadertext {
  color: rgba(255, 255, 255, 1);
  font-size: 40px;
  text-align: left;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
  margin-left: 355px;
}

.congtentmiddle {
  width: 1200px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: -42px;
  display: flex;
  justify-content: center;
  padding-top: 47px;
}

.congtentmiddled {
  width: 1200px;
  height: 446px;
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: -42px;
  display: flex;
  justify-content: center;
}

.congtentmiddle_top {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
}

.congtentmiddle_toptext {
  width: 64px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  text-align: right;
  font-family: SourceHanSansSC-regular;
}

.congtentmiddle_toptextinput {
  width: 492px;
  height: 50px;
  line-height: 50px;
  background-color: rgba(245, 247, 250, 1);
  text-align: left;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  color: rgba(192, 196, 204, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 12px;
}

.congtentmiddle_middle {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 auto;
  margin-top: 24px;
}

.congtentmiddle_bootm {
  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 auto;
  margin-top: 24px;
}

.congtentmiddle_toptextinputmiddle {
  width: 340px;
  height: 49px;
  line-height: 49px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  margin-left: 12px;
}

.congtentmiddle_box {
  width: 120px;
  height: 49px;
  background-color: rgba(255, 255, 255, 1);
  text-align: center;
  /* border: 1px solid rgba(228, 231, 237, 1); */
  margin-left: 30px;
}

/deep/.el-form-item__label {
  line-height: 50px !important;
}

/deep/.el-input__inner {
  height: 49px;
  line-height: 49px;
  padding: 0 12;
  border-radius: 0px;
}

/deep/.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 110%;
  left: 14px;
}

/*  */

.congtentfooter {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.congtentfooterleft {
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  background-color: rgba(67, 147, 245, 1);
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
}

.congtentfooterleft:hover {
  cursor: pointer;
}

.congtentfooterright {
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 4px;
  background-color: white;
  text-align: center;
  border: 1px solid rgba(67, 147, 245, 1);
  margin-left: 35px;
  color: rgba(67, 147, 245, 1);
  font-size: 16px;
}

.congtentfooterright:hover {
  cursor: pointer;
}

.congtentfooterno {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  margin-top: 40px;
  cursor: pointer;
}

.congtentfooternoimg {
  width: 16px;
  height: 16px;
}

.congtentfooternotext {
  color: rgba(67, 147, 245, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 5px;
}

.congtentfooternotexttwo {
  color: rgba(102, 102, 102, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* 弹窗内容 */
.showtaostMiddle {
  width: 380px;
  height: 83px;

  border-radius: 4px;
  background-color: #edf5ff;
  border: 1px solid rgba(67, 147, 245, 1);
  position: absolute;
  top: 25px;
  left: 40%;
  display: flex;
  flex-direction: column;
}

.showtaostMiddletop {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 24px;
  margin-top: 15px;
}

.showtaostMiddletoperror {
  width: 26px;
  height: 26px;
}

.showtaostMiddletoptext {
  color: rgba(16, 16, 16, 1);
  font-size: 16px;
  text-align: left;
  font-family: SourceHanSansSC-medium;
  font-weight: bold;
  margin-left: 12px;
}

.showtaostMiddlebottom {
  color: rgba(102, 102, 102, 1);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-left: 62px;
  margin-top: 8px;
}

.congtentresult {
  width: 1200px;
  /* height: 310px; */
  background-color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.contentresulttext {
  color: rgba(16, 16, 16, 1);
  font-size: 22px;
  text-align: left;
  font-family: SourceHanSansSC-medium;
  margin-left: 30px;
}

.congtentresultarr {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contentresulttextline {
  width: 1140px;
  height: NaNpx;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  margin-top: 16px;
}

.congtentresultimg {
  width: 200px;
  height: 138px;
  margin-top: 31px;
}

.congtentresultimgtext {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  text-align: left;
  font-family: SourceHanSansSC-regular;
  margin-top: 35px;
  margin-bottom: 45px;
}

.congtentHaveresult {
  width: 1150px;
  background-color: rgba(255, 255, 255, 1);

  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin-top: 10px;
  margin-left: 30px;
  margin-bottom: 20px;
}

.congtentHaveresulttop {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.congtentHaveresulttopleft {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #ebecec;
  margin-bottom: -1px;
  margin-left: -1px;
}

.congtentHaveresulttoplefttxt {
  width: 188px;
  height: 60px;
  display: flex;
  align-items: center;
  background-color: rgba(245, 246, 248, 1);
  text-align: left;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
}

.congtentHaveresulttopleftnumber {
  width: 342px;
  height: 60px;
  display: flex;
  align-items: center;
  /* line-height: 60px; */
  background-color: rgba(255, 255, 255, 1);
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
  display: flex;
  align-items: center;
  overflow: auto;
}

.congtentresultimage {
  margin: 0 auto;
}

.contentresulttextheader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.contentresulttextdown {
  width: 80px;
  height: 40px;
  line-height: 40px;
  background-color: rgba(241, 242, 244, 1);
  text-align: center;
  margin-right: 30px;
  cursor: pointer;
}

/* 公积金打印页面 */
/* // 生成页面部分 */
.mainCenterMains {
  width: 740px;
  overflow: auto;
  margin: 15px auto 0;
  background-color: white;
}

.MidSpaceTopTitles {
  width: 695px;
  margin: 10px auto;
}

.MidSpaceTopStyle {
  margin: 13px auto 0;
  width: calc(100% - 20px);
  border: 2px solid #ddd;
  border-top: none;
  border-left: none;
  border-right: none;
  height: 45px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
}

.MidSpaceTopPic {
  flex: 1;
  width: 100%;
  height: 28px;
  line-height: 35px;
  display: flex;
  justify-content: flex-start;
  font-size: 24px;
}

.MidSpaceTopPic span {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}

/deep/.MidSpaceTopNum {
  font-size: 16px;
  font-weight: none;
  height: 28px;
  line-height: 28px;
}

.MidSpaceEr {
  margin-top: 15px;
  height: 60px;
  width: 100%;
}

.MidSpaceName img {
  width: 60px;
  height: 60px;
  border: 1px solid black;
  float: right;
  line-height: 40px;
}

.MidSpaceName {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
}

/deep/.MidSpaceTopNum {
  font-size: 16px;
  font-weight: none;
  height: 28px;
  line-height: 28px;
}

.MidSpaceEr {
  margin-top: 15px;
  height: 60px;
  width: 100%;
}

.MidSpaceName img {
  width: 60px;
  height: 60px;
  border: 1px solid black;
  float: right;
  line-height: 40px;
}

.MidSpaceName {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
}

.MidSpacePer1 {
  width: calc(100% - 20px);
  margin: 25px auto 0;
  height: 20px;
  font-size: 18px;
}

.MidSpacePerName1 {
  margin-left: 10px;
  font-weight: bold;
}

.MidSpacePerId1 {
  margin-left: 10px;
}

.MidSpacePerInfo1 {
  width: calc(100% - 20px);
  text-indent: 2em;
  margin: 15px auto 0;
  line-height: 40px;
  height: 20px;
  font-size: 18px;
}

.MidSpaceComName {
  font-weight: bold;
}

.MidSpacePerData {
  height: 30px;
  line-height: 20px;
  font-weight: bold;
}

.MidSpaceBottom1 {
  width: calc(100% - 140px);
  margin: 30px auto 0;
  height: 20px;

  text-align: left;
  font-size: 18px;
}

.MidSpaceBottomRight1 {
  width: 150px;
  position: relative;
  left: -10px;
  top: -65px;
  font-size: 16px;
  float: right;
  text-align: center;
  position: relative;
}

.namesssss {
  text-align: center;
  width: 150px;
  margin-top: -55px;
}

.MidSpaceBottomRightDate1 {
  width: 150px;
  text-align: center;
  margin: 8px auto 0;
}

.Cross {
  width: 25%;
  height: 1px;
  margin-left: 70px;
  border-top: solid black 1px;
}

.sTable {
  width: calc(100% - 20px);
  font-size: 20px;
  margin: 80px auto 0;
  display: flex;
  text-align: center;
  flex-wrap: wrap;
}

.congtentHaveresulttoplefted {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid black;
  margin-bottom: -1px;
  /* margin-left: -1px; */
}

.congtentHaveresulttoplefttxted {
  width: 188px;
  /* height: 60px; */
  display: flex;
  align-items: center;

  text-align: left;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;

  padding-top: 30px;
  padding-bottom: 30px;
}

.congtentHaveresulttopleftnumbered {
  width: 342px;

  display: flex;
  align-items: center;
  /* line-height: 60px; */
  padding-top: 30px;
  padding-bottom: 30px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  padding-left: 14px;
  display: flex;
  align-items: center;
  border-left: 1px solid black;
}

.wrap {
  height: calc(100vh - 100px);
  overflow: auto;
  background: #f5f5f5;
  padding-top: 24rpx;
}
</style>
<style  lang="scss">
.el-message {
  display: flex;
  width: 380px;
  height: 83px;
  line-height: 20px;
  border-radius: 4px;
  background-color: #edf5ff !important;
  text-align: center;
  border: 1px solid rgb(67, 147, 245) !important;
  align-items: flex-start !important;
}

.myicon {
  width: 26px;
  height: 26px;
  background-image: url("../assets/mess.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.el-message p {
  margin-top: 7px !important;
}
</style>
